import _slicedToArray from "/Users/jakubpsenda/jakub/projekty/projekty/gatsby_martin_github/video/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/Users/jakubpsenda/jakub/projekty/projekty/gatsby_martin_github/video/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/Users/jakubpsenda/jakub/projekty/projekty/gatsby_martin_github/video/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["bsPrefix", "className", "children", "aria-labelledby", "placement", "responsive", "show", "backdrop", "keyboard", "scroll", "onEscapeKeyDown", "onShow", "onHide", "container", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "onEntered", "onExit", "onExiting", "onEnter", "onEntering", "onExited", "backdropClassName", "manager", "renderStaticNode"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import useBreakpoint from '@restart/hooks/useBreakpoint';
import useEventCallback from '@restart/hooks/useEventCallback';
import * as React from 'react';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import BaseModal from '@restart/ui/Modal';
import Fade from './Fade';
import OffcanvasBody from './OffcanvasBody';
import OffcanvasToggling from './OffcanvasToggling';
import ModalContext from './ModalContext';
import NavbarContext from './NavbarContext';
import OffcanvasHeader from './OffcanvasHeader';
import OffcanvasTitle from './OffcanvasTitle';
import { useBootstrapPrefix } from './ThemeProvider';
import BootstrapModalManager, { getSharedManager } from './BootstrapModalManager';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  scroll: false,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  placement: 'start',
  renderStaticNode: false
};

function DialogTransition(props) {
  return /*#__PURE__*/_jsx(OffcanvasToggling, _objectSpread({}, props));
}

function BackdropTransition(props) {
  return /*#__PURE__*/_jsx(Fade, _objectSpread({}, props));
}

var Offcanvas = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      ariaLabelledby = _ref['aria-labelledby'],
      placement = _ref.placement,
      responsive = _ref.responsive,
      show = _ref.show,
      backdrop = _ref.backdrop,
      keyboard = _ref.keyboard,
      scroll = _ref.scroll,
      onEscapeKeyDown = _ref.onEscapeKeyDown,
      onShow = _ref.onShow,
      onHide = _ref.onHide,
      container = _ref.container,
      autoFocus = _ref.autoFocus,
      enforceFocus = _ref.enforceFocus,
      restoreFocus = _ref.restoreFocus,
      restoreFocusOptions = _ref.restoreFocusOptions,
      onEntered = _ref.onEntered,
      onExit = _ref.onExit,
      onExiting = _ref.onExiting,
      onEnter = _ref.onEnter,
      onEntering = _ref.onEntering,
      onExited = _ref.onExited,
      backdropClassName = _ref.backdropClassName,
      propsManager = _ref.manager,
      renderStaticNode = _ref.renderStaticNode,
      props = _objectWithoutProperties(_ref, _excluded);

  var modalManager = useRef();
  bsPrefix = useBootstrapPrefix(bsPrefix, 'offcanvas');

  var _ref2 = useContext(NavbarContext) || {},
      onToggle = _ref2.onToggle;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showOffcanvas = _useState2[0],
      setShowOffcanvas = _useState2[1];

  var hideResponsiveOffcanvas = useBreakpoint(responsive || 'xs', 'up');
  useEffect(function () {
    // Handles the case where screen is resized while the responsive
    // offcanvas is shown. If `responsive` not provided, just use `show`.
    setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
  }, [show, responsive, hideResponsiveOffcanvas]);
  var handleHide = useEventCallback(function () {
    onToggle == null ? void 0 : onToggle();
    onHide == null ? void 0 : onHide();
  });
  var modalContext = useMemo(function () {
    return {
      onHide: handleHide
    };
  }, [handleHide]);

  function getModalManager() {
    if (propsManager) return propsManager;

    if (scroll) {
      // Have to use a different modal manager since the shared
      // one handles overflow.
      if (!modalManager.current) modalManager.current = new BootstrapModalManager({
        handleContainerOverflow: false
      });
      return modalManager.current;
    }

    return getSharedManager();
  }

  var handleEnter = function handleEnter(node) {
    if (node) node.style.visibility = 'visible';

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    onEnter == null ? void 0 : onEnter.apply(void 0, [node].concat(args));
  };

  var handleExited = function handleExited(node) {
    if (node) node.style.visibility = '';

    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    onExited == null ? void 0 : onExited.apply(void 0, args);
  };

  var renderBackdrop = useCallback(function (backdropProps) {
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, backdropProps), {}, {
      className: classNames("".concat(bsPrefix, "-backdrop"), backdropClassName)
    }));
  }, [backdropClassName, bsPrefix]);

  var renderDialog = function renderDialog(dialogProps) {
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({}, dialogProps), props), {}, {
      className: classNames(className, responsive ? "".concat(bsPrefix, "-").concat(responsive) : bsPrefix, "".concat(bsPrefix, "-").concat(placement)),
      "aria-labelledby": ariaLabelledby,
      children: children
    }));
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!showOffcanvas && (responsive || renderStaticNode) && renderDialog({}), /*#__PURE__*/_jsx(ModalContext.Provider, {
      value: modalContext,
      children: /*#__PURE__*/_jsx(BaseModal, {
        show: showOffcanvas,
        ref: ref,
        backdrop: backdrop,
        container: container,
        keyboard: keyboard,
        autoFocus: autoFocus,
        enforceFocus: enforceFocus && !scroll,
        restoreFocus: restoreFocus,
        restoreFocusOptions: restoreFocusOptions,
        onEscapeKeyDown: onEscapeKeyDown,
        onShow: onShow,
        onHide: handleHide,
        onEnter: handleEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleExited,
        manager: getModalManager(),
        transition: DialogTransition,
        backdropTransition: BackdropTransition,
        renderBackdrop: renderBackdrop,
        renderDialog: renderDialog
      })
    })]
  });
});
Offcanvas.displayName = 'Offcanvas';
Offcanvas.defaultProps = defaultProps;
export default Object.assign(Offcanvas, {
  Body: OffcanvasBody,
  Header: OffcanvasHeader,
  Title: OffcanvasTitle
});